import api from "./base-api"
import {v4 as uuidv4} from "uuid";

const clockmakerAnalyticalDataApiV1 = api.injectEndpoints({
    endpoints: (build) => ({
        getConsumablesV1CM: build.query({
            query: ({
                userId,
                depth = 0,
                from = new Date().toISOString().split("T")[0],
                to = from
            }) => {
                return `v1/clockmaker/analytical-data/${userId}/consumables?depth=${depth}&from=${from}&to=${to}`
            },
            transformResponse: (response) => {
                const rows = response.map((row) => ({id: uuidv4(), ...row}));
                return {rows};
            },
        }),
        getEnvironmentsV1CM: build.query({
            query: ({
                userId = "",
                depth = 0,
                limit = 100,
                page = 0
            }) => `v1/clockmaker/analytical-data/${userId}/environments?depth=${depth}&limit=${limit}&page=${page}`
        }),
        getLevelsV1CM: build.query({
            query: ({
                userId = "",
                depth = 0,
                limit = 100,
                page = 0
            }) => `v1/clockmaker/analytical-data/${userId}/levels?depth=${depth}&limit=${limit}&page=${page}`
        }),
        getPaymentsV1CM: build.query({
            query: ({
                userId = "",
                depth = 0,
                limit = 100,
                page = 0
            }) => `v1/clockmaker/analytical-data/${userId}/payments?depth=${depth}&limit=${limit}&page=${page}`
        }),
        getPurchasesV1CM: build.query({
            query: ({
                userId = "",
                depth = 0,
                limit = 100,
                page = 0
            }) => `v1/clockmaker/analytical-data/${userId}/purchases?depth=${depth}&limit=${limit}&page=${page}`
        }),
        getPurchaseV1CM: build.query({
            query: ({
                userId = "",
                depth = 0,
                limit = 100,
                page = 0,
                payload = 0
            }) => `v1/clockmaker/analytical-data/${userId}/purchase?depth=${depth}&limit=${limit}&page=${page}&payload=${payload}`
        }),
        getUserInfoV1CM: build.query({
            query: (
                userId = "",
                limit = 100,
                page = 0
            ) => `v1/clockmaker/analytical-data/${userId}/user-info?limit=${limit}&page=${page}`
        }),
    }),
    overrideExisting: false
})

export const {
    useGetConsumablesV1CMQuery,
    useGetEnvironmentsV1CMQuery,
    useGetUserInfoV1CMQuery,
    useGetLevelsV1CMQuery,
    useGetPaymentsV1CMQuery,
    useGetPurchasesV1CMQuery,
    useGetPurchaseV1CMQuery
} = clockmakerAnalyticalDataApiV1
